import styled from 'styled-components';
import { space } from 'styled-system';

import { Box, Text } from '@stashinvest/ui';

export const SignUpContent = styled(Box)`
	width: 100%;
`;
SignUpContent.displayName = 'SignUpContent';

export const SignUpLayout = styled.main`
	min-height: 90vh;
	position: relative;
	background-color: ${({ theme }) => theme.colors.bgPrimary};
`;
SignUpLayout.displayName = 'SignUpLayout';

export const SignUpStep = styled.div`
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	width: 90%;
	margin: 0 auto 0 auto;
	padding: 1em 0;
	max-width: 32rem;

	${({ theme }) => theme.mediaQueries.tablet} {
		padding: 2em 0 1em 0;
		max-width: 51.25rem;
	}
`;
SignUpStep.displayName = 'SignUpStep';

export const SignUpScreen = styled(Box)`
	width: 100%;
	line-height: 1.25;
	max-width: ${({ maxWidth }) => maxWidth || '32rem'};
`;
SignUpScreen.displayName = 'SignUpScreen';

export const SignUpHeading = styled(Text.H1)`
	white-space: pre-wrap;
	font-size: 1.25rem;
	margin-bottom: ${({ theme }) => theme.space.xxs};
	color: ${({ theme }) => theme.colors.textPrimary};

	${space}
	${({ theme }) => theme.mediaQueries.tablet} {
		font-size: 1.75rem;
	}
`;
SignUpScreen.displayName = 'SignUpHeading';

export const DesktopOnly = styled.div`
	display: none;

	${({ theme }) => theme.mediaQueries.desktop} {
		display: block;
		width: ${({ width }) => width || 'inherit'};
	}
`;
DesktopOnly.displayName = 'DesktopOnly';
